const BASE_URL = import.meta.env.VITE_N8N_BASE_URL as string;

function getToken(): string | null {
  return localStorage.getItem('crm-token');
}

export class ApiError extends Error {
  public status: number;
  public body: unknown;

  constructor(status: number, body: unknown) {
    super(`API ${status}`);
    this.status = status;
    this.body = body;
  }
}

export async function n8nFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getToken();
  const baseHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    baseHeaders.Authorization = `Bearer ${token}`;
  }
  const extra = (init?.headers ?? {}) as Record<string, string>;
  const res = await fetch(`${BASE_URL}${path}`, {
    ...init,
    headers: { ...baseHeaders, ...extra },
  });
  if (!res.ok) {
    const body: unknown = await res.json().catch(() => ({}));
    throw new ApiError(res.status, body);
  }
  return (await res.json()) as T;
}
